import React, { Component } from 'react';
import { connect } from 'react-redux';
import SidebarList from 'features/Admin/components/SidebarList';
import ElementFocus from 'features/Admin/components/ElementFocus';
import {
	adminGetConsentRefusalReason,
	adminGetAllConsentRefusalReasons,
	resetFocusConsentRefusalReason,
	initNewConsentRefusalReason,
	adminPatchConsentRefusalReason,
	adminPostConsentRefusalReason,
	adminDeleteConsentRefusalReason,
} from 'services/consentRefusalReason';
import AdminDataContainer from 'features/Admin/components/AdminDataContainer';
import { Grid, Icon } from 'semantic-ui-react';
import RedButton from 'components/Buttons/RedButton';
import GeneralForm from 'features/Admin/ConsentRefusalReasons/Forms/GeneralForm';
import { Form, Formik } from 'formik';
import MainButton from 'components/Buttons/MainButton';
import SecondaryButton from 'components/Buttons/SecondaryButton';
import * as Yup from 'yup';

const schemaValidation = Yup.object().shape({
	label: Yup.string().required('Champ requis'),
	order: Yup.number().required('Champ requis'),
});

class ConsentRefusalReasonsAdmin extends Component {
	componentDidMount() {
		this.getAllElements();
	}

	componentWillUnmount() {
		this.props.resetFocusConsentRefusalReason();
	}

	componentDidUpdate(prevProps, prevState, snapshot) {}

	getAllElements = () => {
		this.props.adminGetAllConsentRefusalReasons();
	};

	focusOnElement = (elt) => {
		this.props.adminGetConsentRefusalReason(elt);
	};

	onAddClick = () => {
		this.props.initNewConsentRefusalReason();
	};

	saveFocus = (values, setSubmitting) => {
		if (values.id === undefined) {
			delete values.id;
			this.props.adminPostConsentRefusalReason(values).then(() => {
				setSubmitting(false);
			});
		} else {
			this.props.adminPatchConsentRefusalReason(values).then(() => {
				setSubmitting(false);
			});
		}
	};

	deleteFocus = () => {
		this.props.adminDeleteConsentRefusalReason(
			this.props.consentRefusalReasons.focus.data
		);
	};

	render() {
		const { consentRefusalReasons } = this.props;
		const { focus, list } = consentRefusalReasons;
		const consentRefusalReason = focus.data;
		const newConsentRefusalReason =
			consentRefusalReason !== null && consentRefusalReason.id === undefined;

		return (
			<div style={styles.adminContainer}>
				<SidebarList
					list={consentRefusalReasons.list}
					categories={[]}
					onElementClick={this.focusOnElement}
					entity="MOTIF DE REFUS DE PRISE EN CHARGE"
					addButtonText="Nouveau motif de refus de prise en charge"
					onAddButtonClick={this.onAddClick}
					defaultLabel={(e) => e.label}
					groupField={false}
					focusedEltId={consentRefusalReason}
				/>

				<ElementFocus
					element={focus}
					list={list}
					entity="Motif de refus de prise en charge"
					icon='info'
				>
					{consentRefusalReason !== null && (
						<Formik
							enableReinitialize
							initialValues={{
								id: consentRefusalReason.id,
								label: consentRefusalReason.label || '',
								order: consentRefusalReason.order || 1,
							}}
							validationSchema={schemaValidation}
							onSubmit={(values, { setSubmitting }) => {
								this.saveFocus(values, setSubmitting);
							}}
						>
							{({ isSubmitting, errors }) => (
								<Form>
									<Grid style={{ margin: 0 }}>
										<Grid.Row columns={1}>
											<Grid.Column>
												<SecondaryButton
													type='button'
													style={{ float: 'left' }}
													onClick={this.props.resetFocusConsentRefusalReason}
												>
													Fermer
												</SecondaryButton>
												<MainButton
													text={<Icon name='save' />}
													type='submit'
													style={{ float: 'left' }}
													isSubmitting={isSubmitting}
													disabled={
														Object.entries(errors).length > 0 &&
														errors.constructor === Object
													}
												>
													{newConsentRefusalReason ? 'Créer' : 'Enregistrer'}
												</MainButton>

												{!newConsentRefusalReason && (
													<RedButton
														text={<Icon name='trash' />}
														type='button'
														onClick={(e) => {
															if (e !== undefined) e.preventDefault();
															this.deleteFocus();
														}}
														style={{ float: 'right' }}
													>
														Supprimer
													</RedButton>
												)}
											</Grid.Column>
										</Grid.Row>

										<Grid.Row columns={1}>
											<Grid.Column>
												<AdminDataContainer
													ribbonColor='red'
													ribbonLabel='Général'
												>
													<GeneralForm />
												</AdminDataContainer>
											</Grid.Column>
										</Grid.Row>
									</Grid>
								</Form>
							)}
						</Formik>
					)}
				</ElementFocus>
			</div>
		);
	}
}

const styles = {
	adminContainer: {
		height: '100%',
		width: '100%',
		paddingTop: 43,
		fontSize: 0,
		display: 'flex',
	},
	blocHeader: {
		backgroundColor: 'rgb(0, 147, 128)',
		padding: 10,
		width: '100%',
		borderRadius: '4px 4px 0 0',
	},
};

const mapStateToProps = (state) => {
	return {
		consentRefusalReasons: state.admin.consentRefusalReasons,
	};
};

const mapDispatchToProps = {
	adminGetAllConsentRefusalReasons,
	adminGetConsentRefusalReason,
	adminPatchConsentRefusalReason,
	adminDeleteConsentRefusalReason,
	resetFocusConsentRefusalReason,
	adminPostConsentRefusalReason,
	initNewConsentRefusalReason,
};

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(ConsentRefusalReasonsAdmin);
